import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "antd";

import { ApplicationsActions, selectCurrentApplicationId } from "@redux";
import { i18, trb } from "@utilities";

export const ConfirmUploadAgreement = ({ onClose }) => {
  const dispatch = useDispatch();
  const appId = useSelector(selectCurrentApplicationId);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    modal.confirm({
      title: trb(i18.ApplicationsLabels.AreYouSure),
      content: trb(i18.Buttons.ConfirmUploadAgreement),
      okText: trb(i18.Buttons.Ok),
      cancelText: trb(i18.Buttons.Cancel),
      onCancel: onClose,
      onOk: async () => await confirmUploadAgreement()
    });
  }, []);

  const confirmUploadAgreement = async () => {
    await dispatch(
      ApplicationsActions.confirmUploadedAgreements(appId, i18.NotificationTitles.SuccessOperation)
    );
    onClose();
  };

  return contextHolder;
};
